import StockView from './views/StockView.vue'

import EggOrdersView from './views/EggOrdersView.vue'
import EggOrderAddView from './views/EggOrderAddView.vue'
import EggOrderView from './views/EggOrderView.vue'

export default [
  { path: '/sales/stock', name: 'sales/stock', component: StockView, meta: { role: 'Sales', title: 'Stock', layout: 'narrow' } },

  { path: '/sales/egg-orders', name: 'sales/egg-orders', component: EggOrdersView, meta: { role: 'Sales', title: 'Egg Orders', layout: 'narrow' } },
  { path: '/sales/egg-order-add', name: 'sales/egg-order-add', component: EggOrderAddView, meta: { role: 'Sales', title: 'New Egg Order', layout: 'narrow' } },
  { path: '/sales/egg-order/:id', name: 'sales/egg-order/by-id', navHide: true, component: EggOrderView, meta: { role: 'Sales', title: 'Egg Order', layout: 'narrow' }, props: true },
]



// WEBPACK FOOTER //
// ./src/sales/routes.js